import React from "react";
import { Checkbox, Typography } from "@mui/material";
import { settings } from "app/settings";
export const CustomFile = ({ data, handleChange, filesToDelete, type = "default" }) => {
  return (
    <div>
      <Typography
        sx={{ marginBottom: "1em", fontSize: "24px", fontStyle: "underline", fontWeight: "600", color: "#000" }}
      >
        Качени файлове
      </Typography>

      {data?.map((file, idx) => (
        <div
          key={idx}
          style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <p style={{ marginRight: "1em" }}>
            Име:<span style={{ fontWeight: "bold" }}> {file.name} </span>
          </p>
          Линк:{" "}
          <a
            href={`${settings.files_url}${file.url}`}
            target="_blank"
            style={{
              margin: "0 10px",
            }}
            rel="noreferrer"
          >
            {`${settings.files_url}${file.url}`}
          </a>
          <Checkbox
            checked={filesToDelete.includes(file.id)}
            name={file.id}
            onChange={() => handleChange(file.id)}
          ></Checkbox>
          Изтрий файл
          {/* <div>
            <FormControlLabel
              control={<Checkbox name={file.id} />}
              onChange={handleChange(file.id)}
              label="Изтрийте"
            />
          </div> */}
        </div>
      ))}
    </div>
  );
};
export const EmptyFiles = () => {
  return (
    <>
      <Typography sx={{ marginBottom: "20px", fontSize: "24px", fontWeight: "bold" }}>Качени файлове</Typography>
      <Typography sx={{ marginBottom: "40px", marginLeft: "34%", fontSize: "1em" }}>Няма качени файлове</Typography>
    </>
  );
};
